import { useMemo } from "react";
import { useShallow } from "zustand/react/shallow";
import { orderItemsByPreferredIds } from "../components/Sidebar.logic";
import { getProjectOrderKey } from "../logicalProject";
import { selectProjectsAcrossEnvironments, useStore } from "../store";
import type { Project } from "../types";
import { useUiStateStore } from "../uiStateStore";

/** All known projects across environments, in the user's sidebar order. */
export function useOrderedProjects(): Project[] {
  const projectOrder = useUiStateStore((store) => store.projectOrder);
  const projects = useStore(useShallow((store) => selectProjectsAcrossEnvironments(store)));
  return useMemo(
    () =>
      orderItemsByPreferredIds({
        items: projects,
        preferredIds: projectOrder,
        getId: getProjectOrderKey,
      }),
    [projectOrder, projects],
  );
}
